import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Notifications from '@kyvg/vue3-notification';
import { defineRule, configure } from 'vee-validate';
import { required, email, min, max, numeric } from '@vee-validate/rules';
import { $filters } from './services/filters';
import './style/main.scss';

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('numeric', numeric);
defineRule('max', max);
defineRule('dcpr', (value) => {
  if (/^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}\d{4}$/.test(value)) return true;
  return 'Invalid CPR number format.';
});

configure({
  generateMessage: (ctx) => {
    const messages = {
      required: 'This field is required.',
      email: 'E-mail address is not valid.',
      min: 'Not enough characters.',
      numeric: 'Field must only contain numbers.',
      max: 'Too many characters.',
    };
    return messages[ctx.rule.name] || `The field ${ctx.field} is invalid.`;
  },
});

//Following code is responsible of closing the menu when clicking outside the popup
let handleOutsideClick;

const closableDirective = {
  beforeMount(el, binding) {
    handleOutsideClick = (e) => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;

      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          const excludedEl = binding.instance.$refs[refName];
          clickedOnExcludedEl = excludedEl.contains(e.target);
        }
      });

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        binding.instance[handler]();
      }
    };
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  },

  unmounted() {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
  },
};

const app = createApp(App);

app.config.globalProperties.$filters = $filters;

app.use(router);
app.use(store);
app.use(Notifications);
app.directive('closable', closableDirective);

app.mount('#app');
